import { Col, Row } from "react-bootstrap";
import { ReactNode } from "react";
import classnames from "classnames";
import {
  Text,
  SelectInput,
  NumberField,
  MultiSelectInput,
  Form,
} from "../Form/Form.tsx";
import { makeTemplateComponent } from "../Elements/Elements.tsx";
import styles from "./Filter.module.css";

const Filter = ({ children, right }: Filter) => {
  return (
    <div>
      <FilterForm>
        <Row className={"mb-3"}>
          {children && (
            <Col xs={12} className={"d-flex flex-row justify-content-center"}>
              <Row className={"text-center"}>{children}</Row>
            </Col>
          )}
          {right && (
            <Col xs={12} className={"d-flex flex-row justify-content-center"}>
              <Row className={"text-center"}>{right}</Row>
            </Col>
          )}
        </Row>
      </FilterForm>
    </div>
  );
};

type Filter = {
  children?: ReactNode;
  right?: ReactNode;
};

export default Filter;

export const FilterForm = (props) => (
  <Form className={styles.filterForm} {...props} />
);

export const FilterFields = makeTemplateComponent("div", styles.filterFields);

export const FilterButtons = makeTemplateComponent("div", styles.filterButtons);

export const FilterRow = makeTemplateComponent("div", styles.filterRow);

const FilterInput = ({ children, label, className }: FilterInput) => (
  <div className={classnames(styles.filter_group, className)}>
    <label className={styles.label}>{label}</label>
    {children}
  </div>
);
type FilterInput = {
  children?: ReactNode;
  label?: string;
  className?: string;
};

export const FilterText = ({
  label,
  submitable,
  ...rest
}: {
  label?: string;
  submitable?: boolean;
}) => (
  <FilterInput label={label} className={styles.filterText}>
    <Text {...rest} className={styles.filterInput} submitable={submitable} />
  </FilterInput>
);

export const FilterNumber = ({ label, ...rest }: { label?: string }) => (
  <FilterInput label={label} className={styles.filterNumber}>
    <NumberField {...rest} className={styles.filterInput} />
  </FilterInput>
);

export const FilterSelect = ({ label, ...rest }: { label?: string }) => (
  <FilterInput label={label} className={styles.filterSelect}>
    <SelectInput {...rest} className={styles.filterInput} />
  </FilterInput>
);

export const FilterMultiSelect = ({ label, ...rest }: { label?: string }) => (
  <FilterInput label={label} className={styles.filterSelect}>
    <MultiSelectInput {...rest} className={styles.filterInput} />
  </FilterInput>
);

export const FilterBoolean = (props) => (
  <FilterSelect
    {...props}
    options={[
      { id: true, label: "Oui" },
      { id: false, label: "Non" },
    ]}
    toOptionLabelFunc={(e) => e.label}
  />
);
